import { render } from "./footerComp.vue?vue&type=template&id=94c2b53a&ts=true"
import script from "./footerComp.vue?vue&type=script&lang=ts"
export * from "./footerComp.vue?vue&type=script&lang=ts"

import "./footerComp.vue?vue&type=style&index=0&id=94c2b53a&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__